module.exports = __webpack_public_path__ + "img/insulation.4f7d6755.svg";